import React from 'react';

import './styles.scss';

const Loader = () => {
  return (
    <div className="loader-gif">
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
